'use client';

import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext';
import { $getSelection, $isRangeSelection, $setSelection } from 'lexical';

export function AllCapsButton() {
    const [editor] = useLexicalComposerContext();

    const handleAllCaps = () => {
        editor.update(() => {
            const selection = $getSelection();
            if ($isRangeSelection(selection)) {
                const selectedText = selection.getTextContent();
                let newText;

                if (
                    selectedText === selectedText.toUpperCase() &&
                    selectedText !== selectedText.toLowerCase()
                ) {
                    const lower = selectedText.toLowerCase();
                    newText = lower.charAt(0).toUpperCase() + lower.slice(1);
                } else if (
                    selectedText.slice(1) ===
                    selectedText.slice(1).toLowerCase()
                ) {
                    const words = selectedText.toLowerCase().split(' ');
                    newText = words
                        .map((w, i) =>
                            i === 0 || w.length >= 4
                                ? w.charAt(0).toUpperCase() + w.slice(1)
                                : w
                        )
                        .join(' ');
                } else {
                    newText = selectedText.toUpperCase();
                }

                selection.insertText(newText);
                const focusOffset = selection.focus.offset;
                selection.anchor.offset = focusOffset - newText.length;
                $setSelection(selection);
            }
        });
    };

    return (
        <button
            type="button"
            className="mdx-btn"
            onMouseDown={(e) => e.preventDefault()}
            onClick={handleAllCaps}
            title="Toggle Case"
            aria-label="Toggle Case"
        >
            <span className="mdx-text-icon">Aa</span>
        </button>
    );
}
